import Vue from "vue";
import App from "./App.vue";
import Template from "./Template.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import "bootstrap-icons/font/bootstrap-icons.css";

import { config } from "../config";
import { rtdbPlugin } from "vuefire";
import { firestorePlugin } from "vuefire";

import VCalendar from "v-calendar";

// Use v-calendar & v-date-picker components
Vue.use(VCalendar);

Vue.use(firestorePlugin);
Vue.use(rtdbPlugin);
library.add(faUserSecret);
Vue.use(VueAxios, axios);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

Vue.config.productionTip = false;
Vue.prototype.$domainfront =
  window.location.host == "localhost:8080"
    ? config.FRONT_URL_DEV
    : config.FRONT_URL_PROD;

Vue.prototype.$domain =
  window.location.host == "localhost:8080"
    ? config.API_URL_DEV
    : config.API_URL_PROD;

axios.defaults.baseURL =
  window.location.host == "localhost:8080"
    ? config.API_URL_DEV
    : config.API_URL_PROD;

Vue.prototype.$queue_url = config.QUEUE_URL;

Vue.prototype.$dga_domain =
  window.location.host == "localhost:8080"
    ? "https://connect.dga.or.th"
    : "https://connect.egov.go.th";

Vue.prototype.$site = config.SITE;
Vue.prototype.$LINE_OA = config.LINE_OA;

if (config.SITE == "ssj_nont") {
  Vue.prototype.$client_secret = "BnLlUq9kccz"; // ConsumerSecret
  Vue.prototype.$client_id = "e93aba32-3833-4feb-8a2c-d9698f8cca17"; // ConsumerKey
} else if (config.SITE == "ssj_angthong") {
  Vue.prototype.$client_secret = "fBst4NJAAqi";
  Vue.prototype.$client_id = "55dd157d-4c07-410c-b2e3-e6dd106d7b5a";
} else if (config.SITE == "ssj_npt") {
  Vue.prototype.$client_secret = "Bdo1G1FVoJe";
  Vue.prototype.$client_id = "c94fbc53-145f-4522-931c-d4137a377631";
}


Vue.prototype.$logo = config.LOGO;

new Vue({
  router,
  store,
  Template,
  render: (h) => h(App),
}).$mount("#app");
